import type { ReactElement } from 'react';
import { useState } from 'react';
import * as React from 'react';
import { Popover, Button } from '@hotjar/hotsauce';
import { useTranslationWithPrefix } from '@hotjar/translations';

interface EnableMfaButtonProps {
  isPopoverVisible: boolean;
  isVisible: boolean;
  onClick: () => void;
}

export const EnableMfaButton = ({
  onClick,
  isVisible,
  isPopoverVisible,
}: EnableMfaButtonProps): ReactElement | null => {
  const { t } = useTranslationWithPrefix('mfa:enable-mfa-button');
  const [popoverVisible, setPopoverVisible] = useState(true);

  const clickHandler = () => {
    setPopoverVisible(false);
    onClick();
  };

  if (!isVisible) {
    return null;
  }

  if (isPopoverVisible) {
    return (
      <Popover visible={popoverVisible} title={t('title')} text={t('description')}>
        <Button kind="secondary" onClick={clickHandler}>
          {t('button-text')}
        </Button>
      </Popover>
    );
  }

  return (
    <Button kind="secondary" onClick={onClick}>
      {t('button-text')}
    </Button>
  );
};
